module.exports = __webpack_public_path__ + "static/img/pet-active.dd0315d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/pet-active.png
// module id = i8o8
// module chunks = 58